import { render, staticRenderFns } from "./MasterContent.vue?vue&type=template&id=13e1a8d8&scoped=true&"
import script from "./MasterContent.vue?vue&type=script&lang=js&"
export * from "./MasterContent.vue?vue&type=script&lang=js&"
import style0 from "./MasterContent.vue?vue&type=style&index=0&id=13e1a8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e1a8d8",
  null
  
)

export default component.exports